import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Dev-only preview: ?demo=plan in the URL bypasses the normal app and
// renders the WeeklyPlanRenderer with mock data. Lets us iterate on the
// plan UI without logging in. Remove this block before merging to main
// if we decide the demo should stay gated behind something else.
import WeeklyPlanRendererDemo from './pages/WeeklyPlanRendererDemo';

const params = new URLSearchParams(window.location.search);
const isDemo = params.get('demo') === 'plan';

// DEV-ONLY: ?preview=home-graphite — the Home "Graphite + Lime" redesign on mock data (no auth / API / AI). The
// NODE_ENV check is constant-folded by the build, so this branch and the preview module are not in production.
let PreviewRoot = null;
if (process.env.NODE_ENV !== 'production' && params.get('preview') === 'home-graphite') {
  PreviewRoot = require('./preview/HomeGraphitePreview').default;
}

// The loading-screen overlay in public/index.html is normally removed by
// App.js after Firebase auth resolves. Demo mode never mounts App, so we
// must dismiss it ourselves — otherwise the screen stays at 'loading'
// indefinitely.
if (isDemo || PreviewRoot) {
  const ls = document.getElementById('loading-screen');
  if (ls) ls.remove();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
// The dev preview renders outside StrictMode: its dev-only double mount aborts the chat's proposal watcher (a ref'd
// AbortController), which production never does — the preview must show what production shows.
root.render(PreviewRoot ? <PreviewRoot /> :
  <React.StrictMode>
    {isDemo
        ? <WeeklyPlanRendererDemo onBack={() => (window.location.search = '')} />
        : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
